(function () {
  const bindCardFigure = (figure) => {
    if (figure.dataset.plpCardBound === 'true') {
      return;
    }

    const carousel = figure.querySelector('scroll-carousel');

    if (!carousel || carousel.cells.length < 2) {
      return;
    }

    figure.dataset.plpCardBound = 'true';

    figure.addEventListener('mouseenter', () => {
      if (carousel.selectedIndex === 0) {
        carousel.select(1, { instant: true });
      }
    });

    figure.addEventListener('mouseleave', () => {
      if (!figure.matches(':focus-within')) {
        carousel.select(0, { instant: true });
      }
    });

    figure.querySelectorAll('.heritage-collection-plp-card__arrow').forEach((arrow) => {
      arrow.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
    });
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-plp-card-figure]').forEach(bindCardFigure);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
